import LoadMoreButton from '@atoms/LoadMoreButton/LoadMoreButton';
import { IMeta } from '@models/IMeta';
import { IProductComparisonCard } from '@models/IProductComparisonCard';
import NavigationCarousel from '@molecules/NavigationCarousel/NavigationCarousel';
import ProductComparisonCard from '@molecules/ProductComparisonCard/ProductComparisonCard';
import slugify from '@utils/helpers/slugify';
import useBreakpoint from '@utils/hooks/useBreakpoint';
import { useState } from 'react';
import { SwiperSlide } from 'swiper/react';

interface Props {
  readonly anchorId: string;
  readonly items: IProductComparisonCard[];
  readonly loadLessLabel: string;
  readonly loadMoreLabel: string;
  readonly meta: IMeta;
  readonly title: string;
}

const ProductComparison = ({
  anchorId = '',
  items,
  loadLessLabel,
  loadMoreLabel,
  meta,
  title,
}: Props) => {
  const [open, setOpen] = useState(false);
  // NIKDD-2729: This is used here to ensure that the loadMore button does not render server-side.
  const breakPoint = useBreakpoint();
  const highlightsCount = items
    ?.map(({ highlights }) => highlights?.length > 5)
    .some(Boolean);

  return (
    <section
      className="component-padding bg-black-100 text-white"
      id={`a-${anchorId}`}
      data-testid="CT-53-Product-Comparison"
    >
      <NavigationCarousel
        id={`product-comparison-${meta?.contentLink ?? ''}`}
        items={items}
        shadows
        title={title}
        dataTestId="CT-53-Product-Comparison-Navigation-Carousel"
      >
        {(itemsToDisplay) =>
          itemsToDisplay.map((item, index) => (
            <SwiperSlide
              className="stretch-card"
              key={slugify(`${item.sku}-${index}`)}
            >
              <ProductComparisonCard
                open={open}
                {...item}
                dataTestId={`CT-53-Product-Comparison-Card-${index}`}
              />
            </SwiperSlide>
          ))
        }
      </NavigationCarousel>

      {highlightsCount && !!breakPoint && (
        <div className="container pt-4">
          <LoadMoreButton
            loadLessLabel={loadLessLabel}
            loadMoreLabel={loadMoreLabel}
            open={open}
            onClick={() => setOpen(!open)}
            dataTestId="CT-53-Product-Comparison-Load-More-Button"
          />
        </div>
      )}
    </section>
  );
};

export default ProductComparison;
